import React, { useMemo } from 'react';
import { Dropdown } from '@carbon/react';

import { useGetVariantGroupQuery } from '@/redux/new_services/variantGroups';

// StreamItemVariantSwitcher — bare dropdown rendered beneath a stream item
// that points at a VariantGroup. Lets the operator switch between named
// variants (e.g. "1 Euro" / "2 Euro") without leaving the stream editor.
// The group name is intentionally omitted: the dropdown's own label tells
// the operator that this select swaps the variant, and removing the tag
// keeps the tile clean.
//
// Loading strategy: when items are added through the picker, the parent
// passes the full group via `inlineGroup` so the dropdown is instantly
// available. After a stream reload only `groupId` is present, so we fall
// back to fetching the group lazily.
const StreamItemVariantSwitcher = ({
  groupId,
  inlineGroup = null,
  variantId = null,
  onChange = () => {},
}) => {
  const { data: fetchedGroup } = useGetVariantGroupQuery(groupId, {
    skip: !groupId || Boolean(inlineGroup),
  });
  const group = inlineGroup || fetchedGroup;

  const items = useMemo(() => {
    return (group?.variants || []).map((v) => ({
      id: v.model.ID,
      label: v.name || `Variante ${v.model.ID}`,
    }));
  }, [group]);

  // Nothing to switch between — no group loaded or only a single variant.
  if (!group || items.length <= 1) return null;

  const selected = items.find((it) => it.id === variantId) || items[0];

  return (
    <Dropdown
      id={`variant-switcher-${groupId}`}
      size="sm"
      titleText=""
      hideLabel
      label="Variante wählen"
      items={items}
      itemToString={(it) => it?.label || ''}
      selectedItem={selected}
      onChange={(e) => onChange(e?.selectedItem?.id || null)}
    />
  );
};

export default StreamItemVariantSwitcher;
